import { render, staticRenderFns } from "./videolist.vue?vue&type=template&id=313a5960&scoped=true&"
import script from "./videolist.vue?vue&type=script&lang=js&"
export * from "./videolist.vue?vue&type=script&lang=js&"
import style0 from "./videolist.vue?vue&type=style&index=0&id=313a5960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313a5960",
  null
  
)

export default component.exports